import { TravelPostPreviewDraft } from '../types';

const STORAGE_PREFIX = 'travelPostPreview:';

const getStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch (err) {
    return null;
  }
};

export const generatePreviewId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `preview-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
};

export const savePreviewDraft = (draft: TravelPostPreviewDraft) => {
  const storage = getStorage();
  if (!storage) return;
  storage.setItem(`${STORAGE_PREFIX}${draft.draftId}`, JSON.stringify(draft));
};

export const loadPreviewDraft = (draftId: string): TravelPostPreviewDraft | null => {
  const storage = getStorage();
  if (!storage) return null;
  const raw = storage.getItem(`${STORAGE_PREFIX}${draftId}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (err) {
    storage.removeItem(`${STORAGE_PREFIX}${draftId}`);
    return null;
  }
};

export const deletePreviewDraft = (draftId: string) => {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(`${STORAGE_PREFIX}${draftId}`);
};
